import { lazy, useEffect } from "react";

import { useFaces, useSourcePhoto, useGlobalLoading, usePageUpdated, useFacebook, useRouter } from "hooks";
import LoadingModal from "components/LoadingModal";

const FaceUploadModal = lazy(() => import("components/FaceUploadModal"));
const PageUpdatedModal = lazy(() => import("components/PageUpdatedModal"));
const FacebookModalNotice = lazy(() => import("components/FacebookModalNotice"));
const ImageUploadModal = lazy(() => import("components/ImageUploadModal"));

const RenderModal = () => {
  const { modalOpened, closeModal: closeFacesModal } = useFaces();
  const { modalOpened: imageUploadModalOpen, closeModal: closeSourcePhotoModal } = useSourcePhoto();
  const { isPending, labelFunc, progress } = useGlobalLoading();
  const { isUpdating } = usePageUpdated(true);
  const { showNoticeModal, changeModalOpenStorage, modalOpen: facebookModalOpen } = useFacebook();
  const { location } = useRouter();

  useEffect(() => {
    if (facebookModalOpen) changeModalOpenStorage(false);
    if (modalOpened) closeFacesModal();
    if (imageUploadModalOpen) closeSourcePhotoModal();
  }, [location.pathname]);

  return (
    <>
      {modalOpened ? <FaceUploadModal /> : null}
      {imageUploadModalOpen ? <ImageUploadModal /> : null}
      {isUpdating ? <PageUpdatedModal /> : null}
      {isPending ? <LoadingModal labelFunc={labelFunc} progress={progress} /> : null}
      {showNoticeModal ? <FacebookModalNotice /> : null}
    </>
  );
};

export default RenderModal;
